@if (facetList$ | async; as facetList) {
  <div class="active-facets">
    @if (facetList?.activeFacets?.length > 0) {
      <h4>
        {{ 'productList.appliedFilter' | cxTranslate }}
      </h4>
    }
    @for (facet of facetList?.activeFacets; track facet) {
      <a
        title="{{ facet.facetValueName }}"
        attr.aria-label="{{ facet.facetValueName }}"
        >
        <span>{{ facet.facetValueName }}</span>
        <div
          class="active-facets__close"
          aria-hidden="true"
          routerLink="./"
          [queryParams]="getLinkParams(facet)"
          [cxFocus]="getFocusKey(facetList, facet)"
          >
          <i class="fa fa-times" aria-hidden="true"></i>
        </div>
      </a>
    }
    @if (facetList?.activeFacets.length > 1) {
      <a class="clear">
        <span>Clear filters</span>
        <div class="active-facets__close" aria-hidden="true" routerLink="./">
          <i class="fa fa-times" aria-hidden="true"></i>
        </div>
      </a>
    }
  </div>
}
